export const PACKAGE = 'package'
export const PARCEL = 'parcel'
export const LETTER = 'letter'
export const BOX = 'box'
